var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"p-3"},[(_vm.iframeSrc)?_c('div',[_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameborder":"0","width":"100%","height":"900","allowtransparency":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }